'use client';

import Link from 'next/link';

export function Footer() {
  return (
    <footer className="bg-white mt-12 border-t">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 justify-items-center">
          {/* Main Section */}
          <div>
            <h3 className="text-sm font-bold text-gray-800 tracking-wider uppercase text-center">
              Take Your AI Attractiveness Test Now
            </h3>
            <ul role="list" className="mt-4 space-y-4">
              <li className="text-center">
                <Link href="/" className="text-base text-gray-600 hover:text-gray-900">
                  Attractiveness Test
                </Link>
              </li>
              <li className="text-center">
                <Link href="/how-pretty-am-i" className="text-base text-gray-600 hover:text-gray-900">
                  How Pretty Am I
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Section */}
          <div>
            <h3 className="text-sm font-bold text-gray-800 tracking-wider uppercase text-center">
              AI Attractiveness Test Terms
            </h3>
            <ul role="list" className="mt-4 space-y-4">
              <li className="text-center">
                <Link href="/contact" className="text-base text-gray-600 hover:text-gray-900">
                  Contact us
                </Link>
              </li>
              <li className="text-center">
                <Link href="/about" className="text-base text-gray-600 hover:text-gray-900">
                  About Us
                </Link>
              </li>
              <li className="text-center">
                <Link href="/privacy" className="text-base text-gray-600 hover:text-gray-900">
                  Privacy Policy
                </Link>
              </li>
              <li className="text-center">
                <Link href="/terms" className="text-base text-gray-600 hover:text-gray-900">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources Section */}
          <div>
            <h3 className="text-sm font-bold text-gray-800 tracking-wider uppercase text-center">
              AI Attractiveness Test Resources
            </h3>
            <ul role="list" className="mt-4 space-y-4">
              <li className="text-center">
                <Link href="/how-old-do-i-look" className="text-base text-gray-600 hover:text-gray-900">
                  How Old Do I Look
                </Link>
              </li>
              <li className="text-center">
                <Link href="/am-i-pretty" className="text-base text-gray-600 hover:text-gray-900">
                  Am I Pretty
                </Link>
              </li>
              <li className="text-center">
                <Link href="/product-hunt" className="text-base text-gray-600 hover:text-gray-900">
                  Product Hunt
                </Link>
              </li>
              <li className="text-center">
                <Link href="/startup-lister" className="text-base text-gray-600 hover:text-gray-900">
                  Startup Lister
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-200 pt-8">
          <p className="text-base text-gray-400 text-center">
            &copy; {new Date().getFullYear()} AI Attractiveness Test. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
